<span class="kd-document-text" [innerHTML]="content"></span>
